import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'

import NavigationHelper from 'layers/navigation/navigationHelper'
import SubNavGetter, {
  SubNavGetterComponentPropTypes,
} from 'layers/content/v2/Hocs/SubNavGetter'
import {
  getThemeFromUrl,
  getProductFromUrl,
  resolveRouteServiceApp,
} from 'utils/productHelpers'

import Component from './component'

function NavigationContainer(props) {
  const theme = getThemeFromUrl()
  const productConfig = getProductFromUrl()

  return <Component product={productConfig} theme={theme} {...props} />
}

const navigationConnect = connect(
  NavigationHelper.mapStateToProps,
  NavigationHelper.mapDispatchToProps,
)

const userConnect = connect(state => {
  const { userAccessManager } = state || {}
  const { claims } = userAccessManager || {}
  const { userProfileManager } = state || {}
  const { profile } = userProfileManager || {}
  const { firstName = '', lastName = '', roles = [] } = profile || {}
  return {
    roles,
    userClaims: claims,
    name: `${firstName} ${lastName}`.trim(),
  }
})

NavigationContainer.propTypes = {
  subNavData: SubNavGetterComponentPropTypes,
}

const subNavGetterOptions = {
  app: () => resolveRouteServiceApp(window.location.pathname),
}

export default compose(
  navigationConnect,
  userConnect,
)(SubNavGetter(NavigationContainer, subNavGetterOptions))
